export default __webpack_public_path__ + "static/tag-do-2-light-01ad119bf52e53223709749b77250e9fa3c21e4529469408d8aad9e380ec823c.png";